/**
 * BEFORE AND AFTER IMAGE
 */
$(document).ready(function ($)
{
    $('.before-after-colors').click(function(event)
    {
        event.preventDefault();
        if(! $(this).hasClass('active'))
        {
            $(this).parents(".colors-list:first").find('.before-after-colors').removeClass('active');
            $(this).addClass('active');

            $(this).parents('.cloth-type-carousel-card:first').find('.before-img').attr('src', $(this).data('before'));
            $(this).parents('.cloth-type-carousel-card:first').find('.beforeafter-color-name').html($(this).find('input[type="radio"]').val());
            $(this).parents('.cloth-type-carousel-card:first').find('.after-img').attr('src', $(this).data('after'));

            if($(this).parents(".cloth-type-carousel-card:first").length) {
                let card = $(this).parents(".cloth-type-carousel-card:first");
                let id = $(this).attr("for");
                card.find(".card-url").hide();

                if(card.find(".card-url[data-relation='" + id + "']").length) {
                    card.find(".card-url[data-relation='" + id + "']").show();
                } else {
                    card.find(".card-url.card-default-url").show();
                }
            }
        }
    });
});